export const FORBIDDEN_REDIRECT_DEBOUNCE_MS = 200

let redirectTimer: ReturnType<typeof setTimeout> | null = null

export function resetForbiddenRedirectTimer (): void {
  if (redirectTimer !== null) {
    clearTimeout(redirectTimer)
    redirectTimer = null
  }
}

export function scheduleForbiddenRedirect (navigate: () => void): void {
  resetForbiddenRedirectTimer()
  redirectTimer = setTimeout(() => {
    redirectTimer = null
    navigate()
  }, FORBIDDEN_REDIRECT_DEBOUNCE_MS)
}
